import Vue from "vue";
import VueRouter from "vue-router";
//import Auth
import Auth from "@/components/auth/Auth.vue";
import Login from "@/components/auth/Login.vue";
import Register from "@/components/auth/Register.vue";
import Reset from "@/components/auth/Reset.vue";
import ResetPass from "@/components/auth/ResetPass.vue";
//Admin section
//import Admin views
import AdminFront from "@/components/admin/Views/AdminFront.vue";
//Import Admins features
import Admins from "@/components/admin/Admins/Admins.vue";
import AdminsEdit from "@/components/admin/Admins/AdminsEdit.vue";
import AdminsNew from "@/components/admin/Admins/AdminsNew.vue";
//import Agencies page
import Agencies from "@/components/admin/Agencies/Agencies.vue";
import AgenciesEdit from "@/components/admin/Agencies/AgenciesEdit.vue";
import AgenciesNew from "@/components/admin/Agencies/AgenciesNew.vue";
import AgenciesBalance from "@/components/admin/Agencies/AgenciesBalance.vue";
import AgenciesShow from "@/components/admin/Agencies/AgenciesShow.vue";
import AgenciesSubShow from "@/components/admin/Agencies/AgenciesSubShow.vue";
import AgenciesApprove from "@/components/admin/Agencies/AgenciesApprove.vue";
import Plans from "@/components/admin/Plans/Plans.vue";
import PlansShow from "@/components/admin/Plans/PlansShow.vue";
import PlansEdit from "@/components/admin/Plans/PlansEdit.vue";

//import Policies page
import Policies from "@/components/admin/Policies/Policies.vue";
import PoliciesShow from "@/components/admin/Policies/PoliciesShow.vue";
//import Transactions page
import Transactions from "@/components/admin/Transactions/Transactions.vue";
//import Summary page
import Summary from "@/components/admin/Summary/Summary.vue";
//import Sales page
import Sales from "@/components/admin/Sales/Sales.vue";
//End of Admin section

// Agency/Provider section
//import Provider pages
import ProviderAgencies from "@/components/agency/Agencies/Agencies.vue";
import ProviderAgenciesEdit from "@/components/agency/Agencies/AgenciesEdit.vue";
import ProviderAgenciesEditPass from "@/components/agency/Agencies/AgenciesEditPass.vue";
import ProviderAgenciesNew from "@/components/agency/Agencies/AgenciesNew.vue";
import ProviderAgenciesShow from "@/components/agency/Agencies/AgenciesShow.vue";

//import Universal feature
import AgencyFront from "@/components/agency/Views/AgencyFront.vue";
import AgencyAccount from "@/components/agency/Account/Account.vue";
import AgenciesBalanceProvider from "@/components/agency/Agencies/AgenciesBalanceProvider.vue";
import AgencyPolicy from "@/components/agency/Policy/NewPolicy/NewPolicy.vue";
import AgencyPolicyTurkey from "@/components/agency/Policy/NewPolicy/NewPolicyTurkey.vue";
import IssuedPolicies from "@/components/agency/Policy/Issued/Issued.vue";
import IssuedPoliciesShow from "@/components/agency/Policy/Issued/IssuedShow.vue";
import AgencyTransactions from "@/components/agency/Transactions/Transactions.vue";
import AgencySales from "@/components/agency/Sales/Sales.vue";
import AgencySummary from "@/components/agency/Summary/Summary.vue";
//End of Agency/Provider section

Vue.use(VueRouter);

var router = new VueRouter({
  routes: [
    {
      path: "/admin",
      component: AdminFront,
      redirect: "/admin/agencies",
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      },
      children: [
        {
          path: "admins",
          component: Admins,
          children: [],
          meta: {
            requiresAuth: true,
            requiresAdmin: true
          }
        },
        {
          path: "admins/new",
          component: AdminsNew,
          meta: {
            requiresAuth: true,
            requiresAdmin: true
          }
        },
        {
          path: "admins/edit/:id",
          component: AdminsEdit,
          meta: {
            requiresAuth: true,
            requiresAdmin: true
          }
        },
        {
          path: "agencies",
          component: Agencies,
          meta: {
            requiresAuth: true,
            requiresAdmin: true
          }
        },
        {
          path: "agencies/new",
          component: AgenciesNew,
          meta: {
            requiresAuth: true,
            requiresAdmin: true
          }
        },
        {
          path: "agencies/edit/:id",
          component: AgenciesEdit,
          meta: {
            requiresAuth: true,
            requiresAdmin: true
          }
        },
        {
          path: "agencies/balance/:id",
          component: AgenciesBalance,
          meta: {
            requiresAuth: true,
            requiresAdmin: true
          }
        },
        {
          path: "agencies/show/:id",
          component: AgenciesShow,
          meta: {
            requiresAuth: true,
            requiresAdmin: true
          }
        },
        {
          path: "agencies/subagency/show/:id",
          component: AgenciesSubShow,
          meta: {
            requiresAuth: true,
            requiresAdmin: true
          }
        },
        {
          path: "agencies/approve",
          component: AgenciesApprove,
          meta: {
            requiresAuth: true,
            requiresAdmin: true
          }
        },
        {
          path: "policies",
          component: Policies,
          meta: {
            requiresAuth: true,
            requiresAdmin: true
          }
        },
        {
          path: "policies/show/:uuid",
          component: PoliciesShow,
          meta: {
            requiresAuth: true,
            requiresAdmin: true
          }
        },
        {
          path: "plans",
          component: Plans,
          meta: {
            requiresAuth: true,
            requiresAdmin: true
          }
        },
        {
          path: "plans/show/:id",
          component: PlansShow,
          meta: {
            requiresAuth: true,
            requiresAdmin: true
          }
        },

        {
          path: "plans/edit/:id",
          component: PlansEdit,
          meta: {
            requiresAuth: true,
            requiresAdmin: true
          }
        },
        {
          path: "transaction",
          component: Transactions,
          meta: {
            requiresAuth: true,
            requiresAdmin: true
          }
        },
        {
          path: "sales",
          component: Sales,
          meta: {
            requiresAuth: true,
            requiresAdmin: true
          }
        },
        {
          path: "summary",
          component: Summary,
          meta: {
            requiresAuth: true,
            requiresAdmin: true
          }
        }
      ]
    },
    {
      path: "/",
      redirect: "/agency"
    },
    {
      path: "/agency",
      component: AgencyFront,
      meta: {
        requiresAuth: true
      },
      redirect: '/agency/issued_policies',
      children: [
        {
          path: "new_insurance",
          component: AgencyPolicy,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "new_insurance_turkey",
          component: AgencyPolicyTurkey,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "issued_policies",
          component: IssuedPolicies,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "issued_policies/show/:id",
          component: IssuedPoliciesShow,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "account",
          component: AgencyAccount,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "agencies",
          component: ProviderAgencies,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "agencies/new",
          component: ProviderAgenciesNew,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "agencies/edit/:id",
          component: ProviderAgenciesEdit,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "agencies/edit/password/:id",
          component: ProviderAgenciesEditPass,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "agencies/balance/:id",
          component: AgenciesBalanceProvider,
          meta: {
            requiresAuth: true,
            requiresAdmin: false
          }
        },
        {
          path: "agencies/show/:id",
          component: ProviderAgenciesShow,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "transaction",
          component: AgencyTransactions,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "sales",
          component: AgencySales,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "summary",
          component: AgencySummary,
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: "/auth",
      component: Auth,
      redirect: "/auth/login",
      children: [
        {
          path: "login",
          component: Login,
          meta: {
            requiresGuest: true
          }
        },
        {
          path: "register",
          component: Register,
          meta: {
            requiresGuest: true
          }
        },
        {
          path: "reset",
          component: Reset,
          meta: {
            requiresGuest: true
          }
        },
        {
          path: "reset-password/token/:token",
          component: ResetPass,
          meta: {
            requiresGuest: true
          }
        }
      ]
    }
  ]
});

export default router;



// WEBPACK FOOTER //
// ./src/routes.js